const CheckIsNumber = value => /^\d+$/.test(value)
export default CheckIsNumber


// WEBPACK FOOTER //
// ./src/dev/validation/CheckIsNumber.js